export const success = { background: '#009900', text: '#F3F3F3' };
